import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "./App/Pages/NotFound";
import ProtectedRoute from "./Config/ProtectedRoute";
import Home from "./App/Home/Home";
import Login from "./App/login/Login"; // Asegúrate de que el archivo se llame Login.js o Login.jsx
import Register from "./App/sigunp/Register"; // Verifica que el archivo Register esté en la carpeta Signup
import ComprarVip from "./App/Vip/ComprarVip";
import ForgotPassword from "./App/Profile/ForgotPassword";
import BetFree from "./App/Free/BetFree";
import HomeBlogs from "./App/Blogs/HomeBlogs";
import Marcadores from "./App/Home/Marcadores";
import ContactForm from "./App/Contact/ContactForm";
import HomeProfile from "./App/Shorts/Profile/HomeProfile";
import SuperPromos from "./App/promos/SuperPromos";
import WalletView from "./App/Wallet/WalletView";
import HomeShop from "./App/shop/HomeShop";
import ProductDetail from "./App/shop/ProductDetail";
import Recharge from "./App/Wallet/Recharge";
import UserProfile from "./App/Profile/UserProfile";
import Chat from "./App/Chat/Chat";
import GameOne from "./App/casino/games/GameOne";
import HomeVip from "./App/Vip/HomeVip";
import LoveYou from "./App/Example/LoveYou";
import { showMobileOnlyMessage } from "./Config/onlyPhone";
import HomeShorts from "./App/Shorts/HomeShort";
import FollowingPage from "./App/Shorts/FollowingPage";
import UploadPage from "./App/Shorts/UploadPage";
import ProfilePage from "./App/Shorts/ProfilePage";
import ChatConversation from "./App/Shorts/ChatConversation";
import ChatHome from "./App/Shorts/ChatHome";
import UserProfileView from "./App/Shorts/Profile/UserProfileView";
import HomeBetting from "./App/betting/home";
import {Navigate} from 'react-router-dom'; // Ruta protegida para
import PaymentPage from "./Payment/Index";
import RegisterAfiliatePage from "./App/Afiliate/Auth/Register";
import DashboardPages from "./App/Afiliate/Dashboard";
import BetHistoryTabs from "./App/Free/BetHistory";
import PublicProfile from "./App/Profile/PublicProfile";
import PrivacyPolicy from "./App/android/PrivacyPolicy";
import VersionWatcher from "./App/config/app/VersionWatcher";

//store
//recharge
function App() {
  useEffect(() => {
    // Llamar a la función cuando el componente se monta
    // showMobileOnlyMessage();
    // 1087 790 916
  }, []);

  return (
    <Router>
      <VersionWatcher />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/es-mx/" element={<Home />} />
        <Route path="/es-ar/" element={<Home />} />
        <Route path="/es-cl/" element={<Home />} />
        <Route path="/es-pe/" element={<Home />} />
        <Route path="/es-es/" element={<Home />} />
        <Route path="/es-ve/" element={<Home />} />
        <Route path="/es-ec/" element={<Home />} />
        <Route path="/es-uy/" element={<Home />} />
        <Route path="/es-bo/" element={<Home />} />
        <Route path="/es-pr/" element={<Home />} />
        <Route path="/es-pa/" element={<Home />} />
        <Route path="/es-gt/" element={<Home />} />
        <Route path="/es-do/" element={<Home />} />
        <Route path="/es-hn/" element={<Home />} />
        {/* <Route path="/" element={<ProtectedRoute element={<Home />} />} /> */}
        <Route
          path="/tips-free"
          element={<ProtectedRoute element={<BetFree />} />}
        />
        <Route
          path="/prediccion-zone/mi-zona"
          element={<ProtectedRoute element={<Home />} />}
        />
        <Route
          path="/home"
          element={<Navigate to="/prediccion-zone/mi-zona" replace />}
        />
        <Route
          path="/home/vip"
          element={<ProtectedRoute element={<HomeVip />} />}
        />
        // Afiliados --- Afiliados
        <Route path="/aliado/unirse" element={<RegisterAfiliatePage />} />
        <Route path="/dashboard/afiliate" element={<DashboardPages />} />
        //
        <Route path="/prediccion-zone/start" element={<Login />} />
        <Route path="/prediccion-zone/join" element={<Register />} />
        <Route path="/profile/:userId" element={<PublicProfile />} />
        <Route path="/comprar-vip" element={<ComprarVip />} />
        <Route path="/prediccion-zone/reinicio" element={<ForgotPassword />} />
        <Route path="/marcadores-en-vivo" element={<Marcadores />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/profile" element={<HomeProfile />} />{" "}
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/support" element={<Chat />} />
        <Route path="/betting" element={<HomeBetting />} />
        <Route path="/prediccion-zone/history" element={<BetHistoryTabs />} />
        ///
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/shorts" element={<HomeShorts />} />
        <Route path="/shorts/:shortId" element={<HomeShorts />} />
        {/* <Route index element={<HomeShorts />} /> */}
        <Route path="following" element={<FollowingPage />} />
        <Route path="upload" element={<UploadPage />} />
        <Route path="/inbox/:userId" element={<ChatConversation />} />
        <Route path="inbox" element={<ChatHome />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="profile-view/:userId" element={<UserProfileView />} />
        <Route path="profile/:userId" element={<ProfilePage />} />
        ///
        {/* Ruta al perfil */}
        <Route path="/promociones-vip" element={<SuperPromos />} />{" "}
        {/* Ruta al perfil */}
        <Route path="/wallet" element={<WalletView />} /> {/* Ruta al perfil */}
        <Route path="/juego/game-one" element={<GameOne />} />{" "}
        <Route path="/blogs" element={<HomeBlogs />} />
        <Route path="/store" element={<HomeShop />} />
        <Route path="/recharge" element={<Recharge />} />
        <Route path="products/:productId" element={<ProductDetail />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
